import { PanelLeftOpen } from "lucide-react";

import { RobotoIconButton } from "@/shared/components/RobotoIconButton";
import { useNavigationSidebar } from "@/shared/state/appSidebar";

export function NavigationToggle() {
  const sidebar = useNavigationSidebar();
  const showNavigationToggle = !sidebar.isSidebarOpen;

  if (!showNavigationToggle) {
    return null;
  }

  return (
    <RobotoIconButton eventName="SidebarOpened" onClick={sidebar.open}>
      <PanelLeftOpen
        style={{
          width: "1.15rem",
          height: "1.15rem",
        }}
      />
    </RobotoIconButton>
  );
}
